/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GroupAdminDto } from '../models/GroupAdminDto';
import type { Pagination1OfGroupAdminDto } from '../models/Pagination1OfGroupAdminDto';
import type { Pagination1OfGroupUserAdminDto } from '../models/Pagination1OfGroupUserAdminDto';
import type { Pagination1OfString } from '../models/Pagination1OfString';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GroupsService {
    /**
     * **Required Policy:** `ViewGroups`
     * @returns GroupAdminDto OK
     * @throws ApiError
     */
    public static getGroupAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GroupAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewGroups`
     * @returns Pagination1OfGroupAdminDto OK
     * @throws ApiError
     */
    public static getGroupsAdmin({
        id,
        name,
        searchWord,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        name?: string,
        searchWord?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfGroupAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/groups',
            query: {
                'id': id,
                'name': name,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewGroups`
     * @returns Pagination1OfGroupUserAdminDto OK
     * @throws ApiError
     */
    public static getGroupUsersAdmin({
        id,
        searchWord,
        page,
        limit,
    }: {
        id: number,
        searchWord?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfGroupUserAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/groups/{id}/users',
            path: {
                'id': id,
            },
            query: {
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewGroups`
     * @returns Pagination1OfString OK
     * @throws ApiError
     */
    public static getGroupUsersAdmin1({
        id,
        searchWord,
        page,
        limit,
    }: {
        id: number,
        searchWord?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfString> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/groups/{id}/phone-numbers',
            path: {
                'id': id,
            },
            query: {
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
